import useAuth from "../../../../shared/Auth/hooks/useAuth";
import {ApplicantUniversityLinkField} from "../../../../types/generated";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

export function useHasUniversityAppliedStatus(): boolean {
    const {slug: universitySlug} = useUniversity();
    const {authState} = useAuth();

    const hasCurrentUniversityApplied = () => {
        const universityLinks: ApplicantUniversityLinkField[] =
            authState?.me?.applicant?.applicantUniversities ?? [];
        const linkWithCurrentUni = universityLinks.find(
            (link) => link.university.slug === universitySlug,
        );

        if (linkWithCurrentUni) {
            return linkWithCurrentUni.applied !== null;
        }

        return false;
    };

    return hasCurrentUniversityApplied();
}
